import { useNavigate } from "react-router-dom";
import { useSnackbar } from "notistack";
import Box from "@mui/material/Box";
import { useQuery } from "@tanstack/react-query";
import { s3baseUrl } from "src/config/config";
import { helping_video_Category_listing_api } from "src/DAL/HelpingVideos/AdminHelpingVideosCategory";
import icons from "src/design-system/icons";
import GrPage from "src/design-system/components/GrPage";
import GrPageHeader from "src/design-system/components/GrPageHeader";
import GrMediaCard from "src/design-system/components/GrMediaCard";
import GrIcon from "src/design-system/components/GrIcon";
import GrCard from "src/design-system/components/GrCard";
import GrEmptyState from "src/design-system/components/GrEmptyState";
import GrLoader from "src/design-system/components/GrLoader";
import { isFirstRow, libraryGridSx } from "../Video/videoHelpers";

/**
 * Helping videos categories (/helping_videos_category): one card per category; a card opens the
 * category's videos.
 */

export default function HelpingVideosCategory() {
  const navigate = useNavigate();
  const { enqueueSnackbar } = useSnackbar();

  const { data: videosCategory = [], isLoading } = useQuery({
    queryKey: ["helpingVideosCategories"],
    queryFn: async () => {
      const postData = {
        search: "",
        type: 1,
      };
      const result = await helping_video_Category_listing_api(postData);
      if (result?.code !== 200) {
        throw new Error(result?.message);
      }
      return result;
    },
    select: (result) => result?.helping_video_categories || [],
    onError: (error) => {
      enqueueSnackbar(error?.message, { variant: "error" });
    },
  });

  const openCategory = (value) =>
    navigate(`/helping_videos_category/helping-videos/${value._id}`, {
      state: value,
    });

  return (
    <GrPage>
      <GrPageHeader title="Helping videos Category" />

      {isLoading ? (
        <GrLoader />
      ) : videosCategory.length > 0 ? (
        <Box sx={libraryGridSx}>
          {videosCategory.map((value, index) => {
            const thumb = value?.image?.thumbnail_1;
            return (
              <GrMediaCard
                eagerImage={isFirstRow(index)}
                key={value?._id || index}
                image={thumb ? s3baseUrl + thumb : null}
                imageAlt={value?.title || ""}
                placeholderIcon={icons.video}
                title={value?.title || ""}
                description={value?.description}
                expandDescription
                onClick={() => openCategory(value)}
              />
            );
          })}
        </Box>
      ) : (
        <GrCard>
          <GrEmptyState
            icon={<GrIcon icon={icons.video} />}
            title="Categories Not Found"
          />
        </GrCard>
      )}
    </GrPage>
  );
}
